import { render, staticRenderFns } from "./NotificationSnackbar.vue?vue&type=template&id=57e0c14c&scoped=true"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=ts"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e0c14c",
  null
  
)

export default component.exports